"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "AutocompleteField",

  props: {
    items: {
      type: Array,
      required: true
    },

    placeholder: {
      type: String,
      required: false,
      default: ""
    }
  },

  computed: {
    classes: function classes() {
      var baseClasses = ["icon-dropdown-wrapper", "clearfix"];

      if (this.color) {
        baseClasses.push("-" + this.color);
      }

      return baseClasses;
    },
    defaultPlaceholder: function defaultPlaceholder() {
      return this.$t("common.placeholders.no_data");
    }
  },

  methods: {
    clicked: function clicked(item) {
      this.$emit("select", item);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/elements/AutocompleteField.vue
// module id = 0SD+
// module chunks = 0 1